import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags/index.ts'
import * as nodes from '/vercel/path0/markdoc/nodes/index.ts'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: JPEG Analysis Data Model\npageTitle: JPEG Analysis Data Model | Increment | Covalent\n---\n\n# {% $markdoc.frontmatter.title %}\n\n## Analyse 40+ NFT marketplaces In 3 Clicks. No SQL!\nNon-fungible tokens (NFTs) are revolutionizing the digital landscape by introducing several unique and innovative properties: they are distinct, provably scarce, tradeable, and interoperable across various applications. NFTs have the potential to enable dynamic new economies within various sectors such as brand building, gaming, digital art, and beyond. Central to this innovation are NFT marketplaces, which provide the necessary infrastructure for users buy and sell their digital items.\n\nThe JPEG Analysis model enables you to monitor every nft sale across 40+ NFT marketplaces on 18 blockchains, featuring top tier marketplaces like Opensea, Looksrare, Blur and much more. With our comprehensive suite of pre-built dashboards, you can easily discover NFTs to invest in, and our dashboards can be fitlered by chain name, protocol name, or collection to suit your investment strategy. As a marketplace, gain a competitive edge with access to crucial user metrics such as user distribution across competitors, MoM retention, LTV, and more.\n{% modeljpegcta /%}\n\n## Browse Metrics\nThe JPEG Analysis page has numerous reach, retention and revenue metrics that you can browse. Easily anlyze data such as sales count, sales volume, average trade size, floor prize, token holders and much more.\n{% diagram slug=\"jpeg-analysis-page\" /%}\n\n\n## Change Filters\nChange the dashboard filters to suit your use case. Compare the number of users buying NFTs across popular L1s or see which Ethereum scalling solution has the most sales volume - it's entirely up to you.\n{% diagram slug=\"jpeg-analysis-filtered\" /%}\n\n## Use Your Custom Analysis\nIncrement has a screenshot feature that enables you to take your analysis anywhere. Share it with your team or write a thread on Twitter.\n{% diagram slug=\"jpeg-analysis-screenshot\" /%}\n\n";
const filepath = "/docs/increment/data-models/jpeg-analysis.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
